window.components.questions = {
    selector: "section[questions]",
    isLoadedByAjax: false,

    init: function () {
        this.events();
    },

    events: function () {
        if (window.components.questions.isLoadedByAjax) {
            $("body").on("click", ".questions-item", this.onClickOpenQuestions);
        } else {
            $(this.selector)
                .find(".questions-items")
                .on("click", ".questions-item", this.onClickOpenQuestions);
        }
        $(this.selector).find("[question]").on("click", this.onClickQuestion);
        $(this.selector).find(".filter svg").on("click", this.onClickFilters);
    },

    onClickFilters: function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        $(this).closest(".questions-categories").toggleClass("active");
    },

    onClickQuestion: function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
        const question = $(this).attr("question");
        const isProduct = $(this).attr("isProduct") === "";

        window.components.questions.setQuestions(
            "<p></p>",
            question,
            isProduct
        );
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            window.components.questions.filter(false);
        } else {
            $(window.components.questions.selector)
                .find("[question]")
                .removeClass("active");
            window.components.questions.filter($(this).html());
            $(this).addClass("active");
        }
        $(this).closest(".questions-categories").removeClass("active");
    },

    filter: (question) => {
        if (question) {
            $(window.components.questions.selector)
                .find(".filter span")
                .html(question);
        } else {
            $(window.components.questions.selector)
                .find(".filter span")
                .html("Filtrar");
        }
    },

    onClickOpenQuestions: function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        $(this).toggleClass("active");
    },

    requestAndSetQuestions: function (url) {
        $(window.components.questions.selector)
            .find(".questions-list")
            .html("<p>Carregando...</p>");
        $.get(url, function (data) {
            $(window.components.questions.selector)
                .find(".questions-list")
                .html(data);
        });
    },

    setQuestions: function (html, id, isproduct = false) {
        if (isproduct) {
            this.requestAndSetQuestions(`/faq/linha-de-produtos/${id}`);
        } else {
            this.requestAndSetQuestions(`/faq/categorias/${id}`);
        }
        window.components.questions.isLoadedByAjax = true;
        this.events();
    },
};
